if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.onSummaryClick = this.onSummaryClick.bind(this);
    }

    connectedCallback() {
      this.singleOpen = this.dataset.singleOpen !== 'false';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));

      this.items.forEach((item) => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.faq-accordion__panel');
        if (!summary || !panel) return;

        this._setPanelState(item, item.hasAttribute('open'));
        summary.addEventListener('click', this.onSummaryClick);
      });
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        item.querySelector('summary')?.removeEventListener('click', this.onSummaryClick);
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      const item = event.currentTarget.closest('.faq-accordion__item');
      if (!item || item.classList.contains('is-animating')) return;

      if (item.hasAttribute('open')) {
        this.close(item);
      } else {
        if (this.singleOpen) {
          this.items.forEach((other) => {
            if (other !== item && other.hasAttribute('open')) this.close(other);
          });
        }
        this.open(item);
      }
    }

    _setPanelState(item, open) {
      const panel = item.querySelector('.faq-accordion__panel');
      if (!panel) return;
      panel.style.gridTemplateRows = open ? '1fr' : '0fr';
      item.classList.toggle('is-open', open);
      const summary = item.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    open(item) {
      const panel = item.querySelector('.faq-accordion__panel');
      if (!panel) return;

      item.setAttribute('open', '');
      if (this.reducedMotion) {
        this._setPanelState(item, true);
        return;
      }

      panel.style.gridTemplateRows = '0fr';
      item.classList.add('is-open');
      item.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => {
        panel.style.gridTemplateRows = '1fr';
      });
    }

    close(item) {
      const panel = item.querySelector('.faq-accordion__panel');
      if (!panel) return;

      if (this.reducedMotion) {
        item.removeAttribute('open');
        this._setPanelState(item, false);
        return;
      }

      item.classList.remove('is-open');
      item.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      item.classList.add('is-animating');
      panel.style.gridTemplateRows = '0fr';

      const finish = () => {
        panel.removeEventListener('transitionend', finish);
        item.removeAttribute('open');
        item.classList.remove('is-animating');
      };

      panel.addEventListener('transitionend', finish);
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
}
